/**
 *
 * @type {string}
 */
const WIDGET_I18N_LANG_DEFAULT = 'nl';

/**
 *
 * @type {string|*|jQuery}
 */
const WIDGET_I18N_LANG = $('html').attr('lang') === undefined ? WIDGET_I18N_LANG_DEFAULT : $('html').attr('lang');

/**
 *
 * @type {{de: {"choose-date-before-option": string, "persons-ex-babys": string, "price-exclusive": string, "per-person": string, "per-person-per-night": string, youngsters: string, babies: string, "price-inclusive": string, "guest-selected-max": string, children: string, "select-holiday": string, "book-now": string, "per-stay": string, from: string, "hour-duration": string, "percent-of-rent": string, calculated: string, "per-kwh": string, "place-option": string, untill: string, "per-unit": string, "tip-read-explanation": string, "no-holiday": string, maximal: string, "per-package": string, with: string, "per-m3": string, "note-guests-over-capacity": string, "select-accommodation": string, "hour-time": string, "holiday-not-possible": string, adult: string, "choose-arrival": string, "per-night": string, "slot-anavailable": string}, nl: {"choose-date-before-option": string, "price-excluding": string, "per-person": string, "per-person-per-night": string, youngsters: string, babies: string, "guest-selected-max": string, children: string, "select-holiday": string, "book-now": string, "per-stay": string, from: string, "hour-duration": string, "percent-of-rent": string, calculated: string, "per-kwh": string, "place-option": string, untill: string, "per-unit": string, "tip-read-explanation": string, "no-holiday": string, maximal: string, "per-package": string, with: string, "per-m3": string, "note-guests-over-capacity": string, "select-accommodation": string, "hour-time": string, "holiday-not-possible": string, adult: string, "choose-arrival": string, "persons-ex-babies": string, "price-including": string, "per-night": string, "slot-anavailable": string}}}
 */
const WIDGET_I18N_TRANSLATIONS = {
    "nl": {
        "adult": "volwassene",
        "adults": "volwassenen",
        "arrival": "Aankomst",
        "babies": "baby's",
        "baby": "baby",
        "book-now": "Boek nu",
        "calculated": "omgerekend",
        "children": "kinderen",
        "choose-arrival": "Kies een aankomstdag",
        "choose-date-before-option": "Kies eerst een aankomst en vertrek, voordat je een optie kunt plaatsen.",
        "departure": "Vertrek",
        "from": "Vanaf",
        "guest-selected-max": "Het geselecteerde aantal gasten overschrijdt het maximum aantal gasten.",
        "holiday-not-possible": "Vakantie niet mogelijk.",
        "hour-duration": "uur",
        "hour-time": "uur",
        "maximal": "Maximaal",
        "no-holiday": "Er is geen vakantie beschikbaar voor de gekozen verblijfsduur. Selecteer andere data.",
        "note-guests-over-capacity": "Let op, het aantal gasten is groter dan de capaciteit van het gekozen verblijf.\nWe hebben het aantal gasten aangepast.",
        "per-person": "p.p.",
        "per-kwh": "per kwh",
        "per-m3": "per m3",
        "per-night": "per nacht",
        "per-package": "per pakket",
        "per-person-per-night": "p.p.p.n",
        "per-stay": "per verblijf",
        "per-unit": "per eenheid",
        "percent-of-rent": "procent van huur",
        "person": "persoon",
        "persons": "personen",
        "persons-ex-babies": "personen exclusief baby's",
        "place-option": "Optie plaatsen",
        "price-excluding": "Prijs exclusief",
        "price-including": "Prijs inclusief",
        "select-accommodation": "Selecteer een verblijf.",
        "select-holiday": "Selecteer een vakantie.",
        "slot-anavailable": "Provided slot is unavailable",
        "tip-read-explanation": "tip: lees bovenstaande toelichting",
        "untill": "Tot",
        "with": "bij",
        "youngsters": "jongeren",
    },
    "de": {
        "adult": "Erwachsene",
        "adults": "Erwachsenen",
        "arrival": "Ankunft",
        "babies": "Babys",
        "baby": "Baby",
        "book-now": "Jetzt buchen",
        "calculated": "umgerechnet",
        "children": "Kinder",
        "choose-arrival": "Anreisetag auswählen",
        "choose-date-before-option": "Wählen Sie eine An- und Abreise, bevor Sie eine Option platzieren können",
        "departure": "Abreise",
        "from": "Von",
        "guest-selected-max": "Die ausgewählte Anzahl an Gästen überschreitet die maximale Anzahl an Gästen.",
        "holiday-not-possible": "Urlaub nicht möglich.",
        "hour-duration": "Stunde",
        "hour-time": "Uhr",
        "maximal": "Maximum",
        "no-holiday": "Für die ausgewählte Aufenthaltsdauer ist kein Feiertag verfügbar. Bitte wählen Sie andere Daten aus.",
        "note-guests-over-capacity": "Bitte beachten Sie, dass die Anzahl der Gäste größer ist als die Kapazität der gewählten Unterkunft.\nWir haben die Anzahl der Gäste angepasst.",
        "per-person": "p.P.",
        "per-kwh": "pro kWh",
        "per-m3": "pro m3",
        "per-night": "pro Nacht",
        "per-package": "pro Paket",
        "per-person-per-night": "p.P.p.N",
        "per-stay": "pro Aufenthalt",
        "per-unit": "pro Einheit",
        "percent-of-rent": "Prozent der Miete",
        "person": "Person",
        "persons": "Personen",
        "persons-ex-babys": "Personen ohne Babys",
        "place-option": "Option platzieren",
        "price-exclusive": "Preis exklusive",
        "price-inclusive": "Preis inklusive",
        "select-accommodation": "Wählen Sie eine Unterkunft aus.",
        "select-holiday": "Wählen Sie einen Feiertag aus.",
        "slot-anavailable": "Der bereitgestellte Steckplatz ist nicht verfügbar",
        "tip-read-explanation": "Tipp: Lesen Sie die Erklärung oben",
        "untill": "Bis",
        "with": "bei",
        "youngsters": "junge Leute",
    }
};

/**
 *
 * @param string
 * @param formatting
 * @param language
 * @returns {*|string}
 */
window.widgetI18n = function (string, formatting = null, language = null) {
    const DEBUG = false;

    /**
     *
     * @returns {string|*|jQuery}
     */
    this.getLang = () => {
        return (language ?? WIDGET_I18N_LANG);
    }

    /**
     *
     * @param string
     * @returns {*}
     */
    this.getString = (string) => {
        let lang = this.getLang();

        // If the language doesn't exist, return the original string.
        if ((WIDGET_I18N_TRANSLATIONS[lang] ?? null) === null) {
            console.error('I18n not found: [' + string + ' (' + lang + ')]');
            return string;
        }

        return (WIDGET_I18N_TRANSLATIONS[lang][string] ?? string);

    }

    /**
     *
     * @param string
     * @param formatting
     * @returns {*|string}
     */
    this.formatting = (string, formatting) => {
        switch (formatting) {
            case 'lc':
            case 'lower':
            case 'lowercase':
                return string.toLowerCase();
                break;
            case 'uc':
            case 'upper':
            case 'uppercase':
                return string.toUpperCase();
                break;
            case 'ucf':
            case 'ucfirst':
                return string.charAt(0).toUpperCase() + string.slice(1);
                break;
            case null:
            default:
                return string;
                break;
        }
    }

    if (DEBUG) {
        console.group({string});
        console.info('lang', this.getLang());
        console.info('result', this.getString(string));
        console.groupEnd(string);
    }

    return this.formatting(this.getString(string));
}

